let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fgyiZ")).then(() => parcelRequire('2ToZM'));